module.exports = __webpack_public_path__ + "img/chanpinyuanxinsheji.37035412.png";